import React from 'react';
import { RouteObject } from 'react-router-dom';

import LanguageValidator from '../components/common/language-validator';

/**
 * Creates route configurations for both with and without language prefix
 * @param path - The base path (e.g., '/register/:hash')
 * @param element - The React element to render
 * @returns Array of route objects with and without language prefix
 */
export function createLocalizedRoutes(path: string, element: React.ReactElement): RouteObject[] {
  return [
    {
      path,
      element,
    },
    {
      path: `/:language${path}`,
      element: <LanguageValidator>{element}</LanguageValidator>,
    },
    {
      path: `/:region/:language${path}`,
      element: <LanguageValidator>{element}</LanguageValidator>,
    },
  ];
}

/**
 * Creates nested route configurations for both with and without language prefix
 * @param path - The base path
 * @param element - The React element to render
 * @param children - Child routes
 * @returns Array of route objects with and without language prefix
 */
export function createLocalizedRoutesWithChildren(
  path: string,
  element: React.ReactElement,
  children?: RouteObject[],
): RouteObject[] {
  return [
    {
      path,
      element,
      children,
    },
    {
      path: `/:language${path}`,
      element: <LanguageValidator>{element}</LanguageValidator>,
      children,
    },
    {
      path: `/:region/:language${path}`,
      element: <LanguageValidator>{element}</LanguageValidator>,
      children,
    },
  ];
}
